<div class="notification-preview-container" *ngIf="notificationSignal()" data-testid="notification-preview-container">

  <!-- Labels for both columns -->
  <div class="row">
    <div class="col-6">
      <div class="preview-label">
        <h6 class="mat-subtitle-1 text-secondary">How it will appear:</h6>
      </div>
    </div>
    <div class="col-6">
      <div class="preview-label">
        <h6 class="mat-subtitle-1 text-secondary">Summary:</h6>
      </div>
    </div>
  </div>

  <!-- Side-by-side layout using Bootstrap grid -->
  <div class="row h-100">
    <!-- Browser Preview Column -->
    <div class="col-6">
      <app-broadcast-notification-browser-preview [notification]="notificationSignal()"></app-broadcast-notification-browser-preview>
    </div>

    <!-- Summary Column -->
    <div class="col-6">
      <div class="d-flex align-items-center h-100">
        <div class="w-100">
          <div class="card border-0">
            <div class="card-body">
              <dl class="row mb-0">
                <dt class="col-sm-4 text-muted">Title:</dt>
                <dd class="col-sm-8">{{ title() }}</dd>

                <dt class="col-sm-4 text-muted">Message:</dt>
                <dd class="col-sm-8">{{ message() }}</dd>

                <dt class="col-sm-4 text-muted">Target:</dt>
                <dd class="col-sm-8">{{ targetSummary() }}</dd>

                <dt class="col-sm-4 text-muted">Display:</dt>
                <dd class="col-sm-8">{{ displayTypeName() }}</dd>

                <dt class="col-sm-4 text-muted">Colors:</dt>
                <dd class="col-sm-8">{{ colorSummary() }}</dd>

                <dt class="col-sm-4 text-muted">Schedule:</dt>
                <dd class="col-sm-8">{{ scheduleSummary() }}</dd>

                <dt class="col-sm-4 text-muted mb-0" data-testid="dismissible-summary">Dismissible:</dt>
                <dd class="col-sm-8 mb-0">
                  <span class="badge {{ isDismissible() ? 'bg-success' : 'bg-danger' }}">
                    {{ isDismissible() ? 'Yes' : 'No' }}
                  </span>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<!-- Fallback when no notification provided -->
<div *ngIf="!notificationSignal()" class="no-notification-fallback">
  <div class="fallback-content">
    <mat-icon class="fallback-icon">preview</mat-icon>
    <p class="fallback-text">No notification data to preview</p>
  </div>
</div>
